/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningBIcon64Regular = forwardRef('NatureFxLightningBIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.617 5.108C34.36 2.83 38 4.062 38 6.931V26h12.465c2.485 0 3.892 2.848 2.383 4.822l-21.465 28.07C29.64 61.17 26 59.937 26 57.068v-19.07H13.535c-2.485 0-3.892-2.848-2.383-4.822L32.617 5.108ZM35 6.931 13.535 35H26a3 3 0 0 1 3 3v19.069l21.465-28.07H38a3 3 0 0 1-3-3V6.932Z" })));
});
